import { useQuery } from "@tanstack/react-query";
import { type ReactNode, createContext, useContext } from "react";

interface Session {
  userId: string | null;
  loading: boolean;
}

const Ctx = createContext<Session>({ userId: null, loading: true });

export function SessionProvider({ children }: { children: ReactNode }) {
  const q = useQuery({
    queryKey: ["whoami"],
    queryFn: async () => {
      // /whoami is a handoff sidecar endpoint — not in openapi.d.ts; raw fetch used
      const resp = await fetch("/whoami", { headers: { accept: "application/json" } });
      if (!resp.ok) throw new Error(`HTTP ${resp.status} ${resp.statusText}`);
      return (await resp.json()) as { user_id: string | null };
    },
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
  return (
    <Ctx.Provider value={{ userId: q.data?.user_id ?? null, loading: q.isLoading }}>
      {children}
    </Ctx.Provider>
  );
}

export function useSession() {
  return useContext(Ctx);
}
